import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { RestApiService } from 'src/app/_core/service/rest-api.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: "text-editor-body",
  templateUrl: "./body.component.html",
  styleUrls: ["./body.component.scss"]
})
export class BodyComponent implements OnInit {
  editor1Linenumber = "1";
  editor2Linenumber = "1";
  editor1LastLinecount = 0;
  editor2LastLinecount = 0;

  fileContent: any;
  content: any = " ";
  sortedResponse: any;
  importContent: any;
  searchValue: any;
  query_conversation: any;
  value = 0;
  sortResponse: any;
  indexResponse: any;
  indexingResponse: any;
  concordanceResponse: any;
  conResponse: any;
  extractorResponse: any;
  extResponse: any;
  showSpinner: boolean = false;

  @ViewChild("inputEditor") inputEditor: ElementRef;
  @ViewChild("inputEditorLinenumber") inputEditorLinenumber: ElementRef;
  @ViewChild("outputEditor") outputEditor: ElementRef;
  @ViewChild("outputEditorLinenumber") outputEditorLinenumber: ElementRef;
  constructor(private restService: RestApiService, private http: HttpClient) {
  }

  ngOnInit(): void {
  }
  public lineCount(event: any, flag) {
    const lineCount = event.target.value;
    const value = lineCount.substr(0, lineCount.selectionStart).split("\n").length;
    if (flag === 1) {
      if (this.editor1LastLinecount !== value) {
        this.editor1LastLinecount = value;
        this.editor1Linenumber = "1";
        for (let i = 0; i < value; i++) {
          this.editor1Linenumber = this.editor1Linenumber.concat("\n" + (i + 2).toString());
        }
      }
    } else if (flag === 2) {
      if (this.editor2LastLinecount !== value) {
        this.editor2LastLinecount = value;
        this.editor2Linenumber = "1";
        for (let i = 0; i < value; i++) {
          this.editor2Linenumber = this.editor2Linenumber.concat("\n" + (i + 2).toString());

        }
      }
    }
  }
  updateScrolledditor1() {
    const scrollEditor = this.inputEditor.nativeElement as HTMLElement;
    const scrollLineNumber = this.inputEditorLinenumber.nativeElement as HTMLElement;
    scrollLineNumber.scrollTop = scrollEditor.scrollTop;
  }
  updateScrolledditor2() {
    const scrollEditor = this.outputEditor.nativeElement as HTMLElement;
    const scrollLineNumber = this.outputEditorLinenumber.nativeElement as HTMLElement;
    scrollLineNumber.scrollTop = scrollEditor.scrollTop;
  }

  public onChange(fileList: FileList): void {
    const file = fileList[0];
    const fileReader: FileReader = new FileReader();
    const self = this;
    fileReader.onloadend = function (x) {
      self.fileContent = fileReader.result;
      self.inputEditor.nativeElement.value = self.fileContent;
      self.importContent = self.fileContent;

    };
    fileReader.readAsText(file);
    console.log("DAtaaaa", file);
  }
  inputEditorClearText() {
    this.inputEditor.nativeElement.value = "";
    this.importContent = "";
  }
  outputEditorClearText() {
    this.outputEditor.nativeElement.value = "";
    this.content = "";
  }
  navigation(value) {
    if (value == "forward") {
      console.log("forward nav");
      this.value += 1;
      console.log(this.value);
    }
  }
  onClickSearch() {
    this.content = this.importContent;
    this.searchValue = this.query_conversation;
  }

  copyInputMessage() {
    navigator.clipboard.writeText(this.content)
  }

  wordSorting(fromWhere: string, flag: boolean = false) {
    let sortRequest;
    let reversed;
    if (fromWhere == "accending")
      reversed = true;
    else
      reversed = false;
    if (fromWhere == "accending" || "desending") {
      const url = `${environment.baseUrl}${environment.sortCall}`;
      if (flag) {
        sortRequest = { "content": this.importContent, "reversed": reversed };
      } else {
        sortRequest = { "content": this.content, "reversed": reversed };
      }
      this.http.post(url, sortRequest)
        .subscribe(res => {
          this.sortedResponse = res;
          this.sortResponse = this.sortedResponse.sortedValue;
          this.content = this.sortedResponse.sortedValue;
        });
    }
  }

  indexing() {
    const url = `${environment.baseUrl}${environment.indexCall}`;
    let indexing: any = { "index": this.importContent.replace(/\r/g, " ") };
    this.http.post(url, indexing)
      .subscribe(res => {
        this.indexingResponse = res;
        this.indexResponse = this.indexingResponse.indexedValue;
        this.content = this.indexingResponse.indexedValue;
      });
    this.query_conversation = "";
  }

  concordanceWord() {
    this.searchValue = this.query_conversation;
    const url = `${environment.baseUrl}${environment.concordanceCall}`;
    let concordance: any = { "content": this.importContent, "searchText": this.searchValue };
    this.http.post(url, concordance)
      .subscribe(res => {
        this.concordanceResponse = res;
        this.conResponse = this.concordanceResponse.concordancValue;
        this.content = this.concordanceResponse.concordancValue;
      });
    this.query_conversation = "";
  }

  OnClickExtract() {
    if (this.importContent != undefined) {
      this.showSpinner = true;
      console.log("New input data Check" + this.importContent)
      const url = `${environment.baseUrl}${environment.extractorCall}`;
      let extract: any = { "content": this.importContent };
      this.http.post(url, extract)
        .subscribe(res => {
          this.extractorResponse = res;
          this.extResponse = this.extractorResponse.extractorValue;
          this.content = this.extractorResponse.extractorValue;
          this.showSpinner = false;
        })
      this.query_conversation = "";
    }
  }
}


